var text_field_default = {
  "root": "_11WWG",
  "text": "F46G7",
  "input": "vBCda",
  "small": "L-nmZ",
  "medium": "Os-Dj",
  "large": "n9DA-",
  "webview": "HTWNJ",
  "endAdornment": "XyhZB",
  "shown": "xfF3P",
  "value": "Ogoq5",
  "spinner": "SKhSJ",
  "spin": "B-Z7F"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
